// Module
var code = `<h3 class="deck-section-title">{{copy}}</h3>
<div class="deck-section-items"></div>
`;
// Exports
module.exports = code;